import React from "react";
import { AiOutlineCopyright } from "react-icons/ai";

const FooterBottom = () => {
  return (
    <div className="w-full bg-[#F5F5F3] group">
      <div className="max-w-container mx-auto border-t-[1px] pt-10 pb-20">
        <p className="flex  lg:hidden text-titleFont font-normal text-center md:items-center justify-center text-lightText duration-200 text-sm">
          <span className="text-md mr-[1px] mt-[2px] md:mt-0 text-center hidden md:inline-flex">
            <AiOutlineCopyright />
          </span>
          Copyright 2024 | Sitio Sports S.A.S. <br/> Todos los derechos reservados 
        </p>
        <p className="hidden lg:flex text-titleFont font-normal text-center md:items-center justify-center text-lightText duration-200 text-sm">
          <span className="text-md mr-[1px] mt-[2px] md:mt-0 text-center hidden md:inline-flex">
            <AiOutlineCopyright />
          </span>
          Copyright 2024 | Sitio Sports S.A.S. Todos los derechos reservados 
        </p>
      </div>
    </div>
  );
};

export default FooterBottom;
